/** Channel a message to a customer went out on. */
export enum CustomerMessageChannelEnum {
  Sms = 'sms',
  Whatsapp = 'whatsapp',
}

export enum CustomerMessageStatusEnum {
  Sent = 'sent',
  /** WhatsApp accepted the message but reported it was never delivered. */
  Failed = 'failed',
}

/** One message the business sent to a customer — an entry in the customer's message history. */
export interface ICustomerMessage {
  id?: string;
  bid: string;
  /** Recipient phone, as sent. */
  phoneNumber: string;
  channel: CustomerMessageChannelEnum;
  /** Readable message text (a WhatsApp template rendered with its parameters). */
  content: string;
  /** WhatsApp template name, for template messages. */
  templateName?: string;
  /** Link the message's button opens, when it has one. */
  buttonUrl?: string;
  status: CustomerMessageStatusEnum;
  failureReason?: string;
  sentAt: Date | string;
}

export interface ICustomerMessagesPage {
  messages: ICustomerMessage[];
  /** Pass as `before` to load the next (older) page; absent when there are no more. */
  nextCursor?: string;
}
